<!-- Personas de la entidad — espejo de /people filtrado a UNA entidad: sin columnas de
     tipo/entidad (redundantes aquí); en su lugar Tipo (responsable fijo vs contacto),
     Observaciones y Fecha de asignación. Estilos del design-system (.ds / _listado). -->
<div class="entity-contacts-container">
	<!-- Loading State -->
	<div class="loading-container" *ngIf="isLoading">
		<mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
		<p class="loading-text">{{ "common.loading" | translate }}</p>
	</div>

	<!-- Card blanca contenedora (decisión Pablo 2026-06-12): tabla, botones y buscador
	     dentro de un panel como el resto de tabs — las filas se confundían con el fondo. -->
	<div class="card people-card" *ngIf="!isLoading">
		<div class="lst">
		<!-- Sin personas en absoluto -->
		<app-empty-state
			*ngIf="!hasContacts"
			icon="person_off"
			[title]="'contacts.noContacts.title' | translate"
			[message]="'contacts.noContacts.message' | translate"
			[ctaLabel]="(config.allowCreate && !config.readonly) ? ('contacts.actions.createFirst' | translate) : ''"
			ctaIcon="person_add"
			(cta)="onCreateContact()"
		></app-empty-state>

		<ng-container *ngIf="hasContacts">
			<div class="lst-filters opx-filters">
				<div class="lst-search">
					<span class="ic"><mat-icon>search</mat-icon></span>
					<input
						type="text"
						[(ngModel)]="searchTerm"
						(ngModelChange)="onSearchChange()"
						[placeholder]="'contacts.search.placeholder' | translate"
						[attr.aria-label]="'contacts.search.placeholder' | translate"
					/>
				</div>
				<button *ngIf="searchTerm" class="opx-clear" (click)="clearSearch()" matTooltip="{{ 'lst.clear' | translate }}"><span class="ic"><mat-icon>filter_alt_off</mat-icon></span></button>
			</div>

			<div class="lst-topbar">
				<span class="cnt"><b>{{ filteredContacts.length }}</b> {{ "header.menu.contacts" | translate | lowercase }}</span>
				<div style="display: flex; align-items: center; gap: 10px">
					<button
						class="btn btn-primary btn-sm"
						(click)="onCreateContact()"
						*ngIf="config.allowCreate && !config.readonly"
					>
						<span class="ic"><mat-icon [inline]="true">add_circle</mat-icon></span>
						{{ "contacts.actions.createNew" | translate }}
					</button>
					<div class="seg opx-seg">
						<button [class.on]="viewMode === 'table'" (click)="viewMode = 'table'"><span class="ic"><mat-icon>table_rows</mat-icon></span>{{ "lst.view.table" | translate }}</button>
						<button [class.on]="viewMode === 'cards'" (click)="viewMode = 'cards'"><span class="ic"><mat-icon>grid_view</mat-icon></span>{{ "lst.view.cards" | translate }}</button>
					</div>
				</div>
			</div>

			<!-- Tabla -->
			<div class="table-card opx-table rows-multi" *ngIf="viewMode === 'table'">
				<table class="ctr" [(dsSortTable)]="filteredContacts">
					<thead>
						<tr>
							<th data-sort="empleadoNombre">{{ "lst.col.person" | translate }}</th>
							<th data-sort="puestoDescription">{{ "lst.col.role" | translate }}</th>
							<th data-sort="esResponsable">{{ "contacts.table.type" | translate }}</th>
							<th data-sort="observaciones">{{ "contacts.table.observations" | translate }}</th>
							<th data-sort="fechaCreacion">{{ "lst.col.assignDate" | translate }}</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let c of pagedContacts; trackBy: trackByContactId">
							<td><span class="person-cell"><app-empleado-avatar [empleado]="c.avatar"></app-empleado-avatar><span class="opx-name">{{ c.empleadoNombre | nameCase }}</span></span></td>
							<td class="opx-muted">{{ c.puestoDescription }}</td>
							<td><span class="opx-badge" [ngClass]="c.esResponsable ? 'info' : 'gray'">{{ (c.esResponsable ? "contacts.table.typeResponsable" : "contacts.table.typeContact") | translate }}</span></td>
							<td class="opx-muted"><span [title]="c.observaciones || ''">{{ (c.observaciones?.length > 40 ? (c.observaciones | slice: 0 : 40) + "…" : c.observaciones) || "—" }}</span></td>
							<td class="opx-muted"><span [matTooltip]="tiempoEnPuesto(c.fechaCreacion)" matTooltipClass="opx-tip" matTooltipPosition="above">{{ c.fechaCreacion | date : "dd/MM/yyyy" }}</span></td>
							<td>
								<span style="display: inline-flex; gap: 6px; align-items: center; justify-content: flex-end">
									<a class="round-btn" *ngIf="!c.esResponsable && config.allowRemove && !config.readonly" matTooltip="{{ 'common.delete' | translate }}" (click)="onRemoveContact(c)"><span class="ic"><mat-icon>delete</mat-icon></span></a>
									<a class="round-btn is-disabled" *ngIf="c.esResponsable && config.allowRemove && !config.readonly" matTooltip="{{ 'lst.responsableNoDelete' | translate }}" matTooltipClass="opx-tip"><span class="ic"><mat-icon>delete</mat-icon></span></a>
									<a class="opx-go ic" matTooltip="{{ (c.esResponsable ? 'contacts.table.goToTab' : 'common.viewDetail') | translate }}" matTooltipClass="opx-tip" (click)="onRowNavigate(c)"><mat-icon>chevron_right</mat-icon></a>
								</span>
							</td>
						</tr>
						<tr *ngIf="!hasFilteredResults"><td colspan="6"><app-empty-state icon="search_off" tone="neutral" [title]="'contacts.search.noResults.title' | translate" [message]="'contacts.search.noResults.message' | translate" [ctaLabel]="searchTerm ? ('lst.clear' | translate) : ''" ctaIcon="filter_alt_off" (cta)="clearSearch()"></app-empty-state></td></tr>
					</tbody>
				</table>
			</div>

			<!-- Tarjetas -->
			<div class="per-grid" *ngIf="viewMode === 'cards'">
				<article class="pcard opx-card persona-card" *ngFor="let c of pagedContacts; trackBy: trackByContactId">
					<div class="pc-head">
						<app-empleado-avatar class="pc-photo" [empleado]="c.avatar"></app-empleado-avatar>
						<div class="pc-id">
							<div class="pc-name">{{ c.empleadoNombre | nameCase }}</div>
							<div class="pc-user">{{ c.puestoDescription }}</div>
						</div>
						<span class="opx-badge pc-type" [ngClass]="c.esResponsable ? 'info' : 'gray'">{{ (c.esResponsable ? "contacts.table.typeResponsable" : "contacts.table.typeContact") | translate }}</span>
					</div>
					<div class="pc-meta">
						<div class="pc-m"><span>{{ "contacts.table.observations" | translate }}</span><b [title]="c.observaciones || ''">{{ (c.observaciones?.length > 34 ? (c.observaciones | slice: 0 : 34) + "…" : c.observaciones) || "—" }}</b></div>
						<div class="pc-m"><span>{{ "lst.col.assignDate" | translate }}</span><b [matTooltip]="tiempoEnPuesto(c.fechaCreacion)" matTooltipClass="opx-tip" matTooltipPosition="above">{{ c.fechaCreacion | date : "dd/MM/yyyy" }}</b></div>
					</div>
					<div class="pc-actions">
						<a class="cbtn" (click)="onRowNavigate(c)"><mat-icon [inline]="true">{{ c.esResponsable ? 'tab' : 'visibility' }}</mat-icon> {{ (c.esResponsable ? 'contacts.table.goToTab' : 'common.view') | translate }}</a>
						<a class="cbtn" *ngIf="!c.esResponsable && config.allowRemove && !config.readonly" (click)="onRemoveContact(c)"><mat-icon [inline]="true">delete</mat-icon> {{ "common.delete" | translate }}</a>
						<a class="cbtn is-disabled" *ngIf="c.esResponsable && config.allowRemove && !config.readonly" matTooltip="{{ 'lst.responsableNoDelete' | translate }}" matTooltipClass="opx-tip"><mat-icon [inline]="true">delete</mat-icon> {{ "common.delete" | translate }}</a>
					</div>
				</article>
				<app-empty-state *ngIf="!hasFilteredResults" icon="search_off" tone="neutral" [title]="'contacts.search.noResults.title' | translate" [message]="'contacts.search.noResults.message' | translate" [ctaLabel]="searchTerm ? ('lst.clear' | translate) : ''" ctaIcon="filter_alt_off" (cta)="clearSearch()"></app-empty-state>
			</div>

			<!-- Paginación -->
			<div class="pager" *ngIf="totalPages > 1">
				<div class="pg-info">{{ currentPage }} / {{ totalPages }}</div>
				<div class="pg-ctrls">
					<button class="pgbtn" [disabled]="currentPage === 1" (click)="goToPage(1)"><span class="ic"><mat-icon>first_page</mat-icon></span></button>
					<button class="pgbtn" [disabled]="currentPage === 1" (click)="goToPage(currentPage - 1)"><span class="ic"><mat-icon>chevron_left</mat-icon></span></button>
					<button class="pgbtn" [disabled]="currentPage === totalPages" (click)="goToPage(currentPage + 1)"><span class="ic"><mat-icon>chevron_right</mat-icon></span></button>
					<button class="pgbtn" [disabled]="currentPage === totalPages" (click)="goToPage(totalPages)"><span class="ic"><mat-icon>last_page</mat-icon></span></button>
				</div>
			</div>
		</ng-container>
		</div>
	</div>
</div>
